import React, { useEffect } from "react";
import { Box } from "components-lib";
import { useNavigate } from "react-router-dom";

// Import modular components
import PatientHeader from "./patient-details/components/PatientHeader";
import MedicalInputSection from "./patient-details/components/MedicalInputSection";
import MedicinesSection from "./patient-details/components/MedicinesSection";
import NextVisitSection from "./patient-details/components/NextVisitSection"; // Updated import
import BottomActionBar from "./patient-details/components/BottomActionBar";
import ConsultationModals from "./patient-details/components/ConsultationModals";
import AutocompleteProvider from "./components/AutocompleteProvider";
import PatientActions from "./patient-details/components/PatientActions.jsx";

// Fix imports for hooks - make sure we're importing the default export
import { usePatientData } from "./patient-details/hooks/usePatientData"; // Changed from { usePatientData }
import { usePatientActions } from "./patient-details/hooks/usePatientActions";
import { useAppointmentPrescription, clearAppointmentPrescriptionCache } from "./patient-details/hooks/useAppointmentPrescription";
import ConsultationToolbar from "views/admin/doctors/patient-details/components/ConsultationToolbar";
import { clearAllCache } from "utils/apiCache";
import { flushLocalParametersToServer } from "services/parametersService";
/**
 * PatientDetails Component - Refactored and Modularized
 *
 * This component has been completely refactored from a 2000+ line monolithic component
 * into focused, manageable modules:
 * - PatientHeader: Patient info display and speech-to-text toggle
 * - PatientActions: Past visits, templates, and action buttons
 * - MedicalInputSection: Voice/Text inputs for medical data with enhanced autocomplete
 * - MedicinesSection: Medicine management with API-based suggestions
 * - NextVisitSection: Next visit and referral management
 * - BottomActionBar: Fixed bottom bar with language and end consultation
 * - ConsultationModals: All modal dialogs
 *
 * HOOKS:
 * - usePatientData: Centralized data management with API integration
 * - usePatientActions: Action handlers and business logic
 *
 * FEATURES PRESERVED:
 * - Enhanced autocomplete with API suggestions from /api/prescription/getDoctorRecc
 * - Speech-to-text functionality
 * - All existing API integrations
 * - Prescription creation and appointment status updates
 * - LocalStorage persistence
 * - Date calculations for medicines and visits
 *
 * The refactored code maintains 100% backward compatibility while improving:
 * - Code maintainability and readability
 * - Component reusability
 * - Debugging capabilities
 * - Testing potential
 * - Performance through focused re-renders */
/*
  Template flow responsibility (short):
  - Holds `templateData` state: the single source of truth for a loaded template.
  - Passes `setTemplateData` into `ConsultationToolbar` / modals so `LoadTemplateModal`
    can call `setTemplateData(...)` after fetching and transforming a server template.
  - Passes `templateData` down to child components (`MedicalInputSection`, `MedicinesSection`, ...)
    which each contain `useEffect([templateData])` logic to normalize & merge the data.
  - See `docs/LOAD_TEMPLATE_FLOW.md` for the full flow.
*/

const PatientDetails = ({ location, onBack }) => {
  const { patient, appointment } = location.state || {};

  const navigate = useNavigate();

  // useEffect(() => {
  //   alert(JSON.stringify(patient));
  // }, [patient]);

  let [templateData, setTemplateData] = React.useState({});
  let [PastpatientSpecifcData, setPastpatientSpecifcData] = React.useState({}); //for data such as allergies and past history

  // useEffect(() => {
  //   console.log(
  //     "🔴 PastpatientSpecifcData Recived at PatientDetails",
  //     JSON.stringify(PastpatientSpecifcData)
  //   );
  // }, [PastpatientSpecifcData]);

  // useEffect(() => {
  //   console.log(
  //     "🔴 Template Data Recived at PatientDetails" +
  //       JSON.stringify(templateData)
  //   );
  // }, [templateData]);

  // useEffect(() => {
  //   // alert(JSON.stringify(templateData));
  //   console.log("🔴" + JSON.stringify(templateData));
  //   // Apply templateData complaints and advices into patientData (avoid duplicates)
  //   if (!templateData || typeof templateData !== "object") return;

  //   // Complaints
  //   const templateComplaints = templateData.complaints || [];
  //   templateComplaints.forEach((tpl) => {
  //     const tplComplaintText = (tpl.complaint || tpl.complaint_text || "").trim();
  //     if (!tplComplaintText) return;

  //     const existsInPatient =
  //       (patientData?.complaints || []).some(
  //         (existing) =>
  //           (existing.complaint || "").toLowerCase() ===
  //           tplComplaintText.toLowerCase()
  //       ) || false;

  //     if (!existsInPatient) {
  //       // set a transient new complaint (if hook exists)
  //       patientData?.setNewComplaint?.({
  //         no: "",
  //         complaint: tplComplaintText,
  //         severity: tpl.severity || "",
  //         duration: tpl.duration || "",
  //         date: tpl.date || "",
  //       });

  //       // append to complaints
  //       patientData?.setComplaints?.((prev = []) => [
  //         ...prev,
  //         {
  //           ...tpl,
  //           complaint: tplComplaintText,
  //           no: (prev?.length || 0) + 1,
  //         },
  //       ]);

  //       // clear suggestions if hook exists
  //       patientData?.setSeveritySuggestions?.([]);

  //       // notify user that complaint was added from template
  //       window.alert(`Added complaint from template: "${tplComplaintText}"`);
  //     }
  //   });

  //   // Advices
  //   const templateAdvices = templateData.advices || [];
  //   templateAdvices.forEach((tpl) => {
  //     // support both "advice" and possible "advice_text" keys
  //     const tplAdviceText = (tpl.advice || tpl.advice_text || "").trim();
  //     if (!tplAdviceText) return;

  //     const existsInAdvices =
  //       (patientData?.advicesData || []).some(
  //         (existing) =>
  //           (existing.advice || "").toLowerCase() ===
  //           tplAdviceText.toLowerCase()
  //       ) || false;

  //     if (!existsInAdvices) {
  //       const newAdviceEntry = {
  //         advice: tplAdviceText,
  //         id: tpl.id || undefined,
  //         date: tpl.date || undefined,
  //       };

  //       patientData?.setAdvicesData?.((prev = []) => [...prev, newAdviceEntry]);

  //       // notify user that advice was added from template
  //       window.alert(`Added advice from template: "${tplAdviceText}"`);
  //     }
  //   });

  // }, [templateData]);

  // Extract IDs from appointment or patient data
  const appointment_id = appointment?.id || patient?.appointment_id;
  // Try to get doctor_id from multiple sources - appointment data has precedence
  const doctor_id =
    appointment?.doctor_id ||
    patient?.doctor_id ||
    JSON.parse(localStorage.getItem("tokenPayload") || "{}")?.userId ||
    1; // Default to 1 if not available
  console.log("🔥 DOCTOR ID EXTRACTION:", {
    appointment_doctor_id: appointment?.doctor_id,
    patient_doctor_id: patient?.doctor_id,
    localStorage_doctor_id: JSON.parse(
      localStorage.getItem("tokenPayload") || "{}"
    )?.userId,
    final_doctor_id: doctor_id,
  });

  // Use custom hooks for data and actions management
  const patientData = usePatientData(patient, doctor_id);

  const {
    data: appointmentPrescription,
    loading: isPrescriptionLoading,
    error: prescriptionError,
    refetch: refetchAppointmentPrescription,
  } = useAppointmentPrescription(appointment_id);

  useEffect(() => {
    // if (appointment_id && patientData) {
    //   localStorage.setItem(
    //     `PatientData_${appointment_id}`,
    //     JSON.stringify(patientData)
    //   );
    // }
  }, [appointment_id, patientData]);

  const patientActions = usePatientActions(patient, patientData);
  console.log(
    "the patient and appoinement id here is in the compenent PatientDetails.js : "
  );

  const handleSubmit = () => { }

  return (
    <Box
      pt={{ base: "130px", md: "40px", xl: "40px" }}
      pb="100px"
      // px={{ base: "16px", md: "24px", xl: "32px" }}
      // w="100%"

      // maxW="1600px"
      mx="auto"
    // overflowX="auto"
    >
      {/* Patient Header Section */}
      <PatientHeader
        patient={patient}
        onBack={onBack || (() => navigate(-1))}
        isSpeechToTextEnabled={patientData.isSpeechToTextEnabled}
        setIsSpeechToTextEnabled={patientData.setIsSpeechToTextEnabled}
        onVideoCallClick={() => {
          // Get the meeting link from the row data
          console.log(JSON.stringify(patient));
          const meetLink = patient.meet_link;

          if (meetLink) {
            // Open the meeting link in a new tab
            window.open(meetLink, "_blank", "noopener,noreferrer");
            if (patientActions && typeof patientActions.toast === "function") {
              patientActions.toast({
                title: "Opening meeting link in new tab",
                description: `${meetLink}`,
                status: "success",
                duration: 7000,
                isClosable: true,
                position: "bottom",
              });
            }
          } else {
            console.warn("No meeting link available for this consultation");
            if (patientActions && typeof patientActions.toast === "function") {
              patientActions.toast({
                title: "No meeting link",
                description: "No meeting link available for this consultation.",
                status: "warning",
                duration: 5000,
                isClosable: true,
                position: "bottom",
              });
            } else {
              console.log(
                "Error Creating a toast from online consultion Meeting link "
              );
            }
          }
        }}
      />

      {/* Consultation Toolbar - placed before MedicalInputSection */}
      <ConsultationToolbar
        patient={patient}
        patientId={patient.patient_pk || patient.id}
        setPastpatientSpecifcData={setPastpatientSpecifcData}
        // patientId={patient.id || patient.patient_id}
        patientData={patientData}
        appointmentId={appointment_id}
        setTemplateData={setTemplateData}
        // consultationData={{
        //   medicines: patientData.medicinesData || [],
        //   advice: patientData.advicesData || [],
        //   complaints: patientData.complaints || [],
        // }}
        // Merging is handled entirely inside LoadTemplateModal
        hasPastVisits={patientData.hasPastVisits}
        forPastVisitIdOfPatient={patientData.forPastVisitIdOfPatient}
        isPastVisitsOpen={patientData.isPastVisitsOpen}
        setIsPastVisitsOpen={patientData.setIsPastVisitsOpen}
        toast={patientActions.toast}
        doctor_id={doctor_id}
      />

      <div style={{borderRadius:"10px", backgroundColor:"#f0f0f0"}}  >
        {/* Medical Input Section with Enhanced Autocomplete */}
        <MedicalInputSection
          PastpatientSpecifcData={PastpatientSpecifcData}
          isSpeechToTextEnabled={patientData.isSpeechToTextEnabled}
          patientData={patientData}
          patientActions={patientActions}
          appointment_id={appointment_id}
          doctor_id={doctor_id}
          templateData={templateData}
          appointmentPrescription={appointmentPrescription}
          handleSubmit
          />

        {/* Medicines Section with API-based Suggestions and Allergy Checking */}
        <AutocompleteProvider doctorId={doctor_id}>
          <MedicinesSection
            templateData={templateData}
            medicinesData={patientData.medicinesData}
            setMedicinesData={patientData.setMedicinesData}
            newMedicineData={patientData.newMedicineData}
            setNewMedicineData={patientData.setNewMedicineData}
            fromDate={patientData.fromDate}
            setFromDate={patientData.setFromDate}
            toDate={patientData.toDate}
            setToDate={patientData.setToDate}
            onAddMedicine={patientActions.handleAddMedicineData}
            onDeleteMedicine={patientActions.handleDeleteMedicine}
            onDurationChange={patientActions.handleDurationChange}
            apiRecommendations={patientData.apiRecommendations}
            // Pass allergy data for conflict checking
            allergicMedicines={patientData.medicines || []}
            appointmentId={appointment_id}
            appointmentPrescription={appointmentPrescription}
          />
        </AutocompleteProvider>

        {/* Next Visit Section - Enhanced with proper persistence */}
        <NextVisitSection
          templateData={templateData}
          nextVisitDuration={patientData.nextVisitDuration}
          setNextVisitDuration={patientData.setNextVisitDuration}
          nextVisitDate={patientData.nextVisitDate}
          setNextVisitDate={patientData.setNextVisitDate}
          referredDoctor={patientData.referredDoctor}
          setReferredDoctor={patientData.setReferredDoctor}
          referredSpeciality={patientData.referredSpeciality}
          setReferredSpeciality={patientData.setReferredSpeciality}
          referredPhone={patientData.referredPhone}
          setReferredPhone={patientData.setReferredPhone}
          referredEmail={patientData.referredEmail}
          setReferredEmail={patientData.setReferredEmail}
          referredHospital={patientData.referredHospital}
          setReferredHospital={patientData.setReferredHospital}
          referredHospitalAddress={patientData.referredHospitalAddress}
          setReferredHospitalAddress={patientData.setReferredHospitalAddress}
          investigation={patientData.investigation}
          setInvestigation={patientData.setInvestigation}
          investigationsList={patientData.investigationsList}
          setInvestigationsList={patientData.setInvestigationsList}
          pastMedication={patientData.pastMedication}
          setPastMedication={patientData.setPastMedication}
          onAddInvestigation={patientActions.handleAddInvestigation}
          onDeleteInvestigation={patientActions.handleDeleteInvestigation}
          onNextVisitDurationChange={patientActions.handleNextVisitDurationChange}
          appointmentId={appointment_id}
          appointmentPrescription={appointmentPrescription}
        />

      </div>
      {/* Bottom Action Bar */}
      <BottomActionBar
        selectedLanguage={patientData.selectedLanguage}
        // onEndConsultation={patientActions.handleEndConsultation}
        onEndConsultation={async () => {
1
          // Flush any locally edited parameters to the server before ending consultation
          try {
            await flushLocalParametersToServer(appointment_id);
          } catch (err) {
            console.warn("Failed to flush local parameters before ending consultation:", err);
            // continue with end consultation flow even if flush fails
          }

          clearAllCache();
          // Clear prescription-specific cache and local text-input caches when ending consultation
          clearAppointmentPrescriptionCache(appointment_id);
          try {
            localStorage.removeItem("textInputsData");
            localStorage.removeItem("unsyncedparameters");
          } catch (err) {
            console.warn("Failed to clear local consultation caches", err);
          }
          // patientData.savePrescriptionState();
          patientActions.handleEndConsultation();
        }}
      />

      {/* All Modals */}
      <ConsultationModals
        patientData={patientData}
        patientActions={patientActions}
        onBack={onBack || (() => navigate(-1))}
        patient={patient}
        setMedicinesData={patientData.setMedicinesData}
        setComplaints={patientData.setComplaints}
        setAdvicesData={patientData.setAdvicesData}
        handleSubmit={handleSubmit}
      />
    </Box>
  );
};

export default PatientDetails;
